import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import File from './File';
var FilesList = /*#__PURE__*/memo(function (_ref) {
  var classes = _ref.classes,
    files = _ref.files,
    imageTypes = _ref.imageTypes,
    imageExtensions = _ref.imageExtensions,
    previewImages = _ref.previewImages,
    cropImages = _ref.cropImages,
    cropTooltip = _ref.cropTooltip,
    handleOnCrop = _ref.handleOnCrop,
    onRemove = _ref.onRemove,
    filesData = _ref.filesData,
    overrides = _ref.overrides;
  var renderFiles = useMemo(function () {
    if (!files.length) return null;
    return files.map(function (file, i) {
      var _newFile$split$pop;
      var newFile = file;
      var fileId = '';
      if (file.file) newFile = file.file;
      // if there is file.file then file.id will be used to keep tracking of the file
      // and the file will be returned with the same format in onRemove and onCrop {id, file}
      if (file.id && file.file) fileId = file.id;
      var isUrl = typeof newFile === 'string';
      var isImage = !isUrl && imageTypes.includes(newFile.type) || isUrl && imageExtensions.includes((_newFile$split$pop = newFile.split('.').pop()) === null || _newFile$split$pop === void 0 ? void 0 : _newFile$split$pop.toLowerCase());
      var preview = previewImages && isImage;
      var crop = cropImages && isImage;
      var data = (filesData === null || filesData === void 0 ? void 0 : filesData[newFile.id]) || {};
      return /*#__PURE__*/React.createElement(File, {
        key: i,
        index: i,
        id: fileId,
        classes: classes,
        crop: crop,
        cropTooltip: cropTooltip,
        loading: data.loading,
        error: data.error,
        progress: data.progress,
        file: newFile,
        isUrl: isUrl,
        onCrop: handleOnCrop,
        onRemove: onRemove,
        overrides: overrides,
        preview: preview
      });
    });
  }, [classes, imageExtensions, imageTypes, cropImages, cropTooltip, files, filesData, handleOnCrop, onRemove, overrides, previewImages]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.filesList
  }, overrides.filesList), renderFiles);
});
export default FilesList;